import { render, staticRenderFns } from "./editPromocode.vue?vue&type=template&id=3bf4eefb"
import script from "./editPromocode.vue?vue&type=script&lang=js"
export * from "./editPromocode.vue?vue&type=script&lang=js"
import style0 from "./editPromocode.vue?vue&type=style&index=0&id=3bf4eefb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports